import app from 'flarum/forum/app';

/**
 * Format a date value (Date | ISO string | undefined) using the forum locale.
 */
export function formatDateTime(value) {
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(value);
  if (isNaN(date.getTime())) return '';
  try {
    const locale = app.locale || app.data?.locale || 'en';
    return new Intl.DateTimeFormat(locale, {
      dateStyle: 'medium',
      timeStyle: 'short'
    }).format(date);
  } catch (e) {
    return date.toLocaleString();
  }
}
flarum.reg.add('cengizkemec-support-tickets', 'forum/utils/format', { formatDateTime: formatDateTime, });